import React from 'react';
import { Modal, Card, Typography, List } from 'antd';

const { Title, Text } = Typography;

const SECTIONS = [
  {
    title: 'Section 16 - Informatory Signs',
    content: [
      'Direction and Place Identification Signs (16.3)',
      'Facility Information Signs (16.3.6-8)',
      'Gantry Mounted Signs (16.3.9)',
      'Tourism Related Signs (16.3.10)',
    ],
  },
  {
    title: 'Section 16.3.1 - Typography',
    content: [
      'English Font: Transport Medium',
      'Hindi Font: Hindi7/Narad Bold',
      'Lowercase with initial uppercase',
      'All text retro-reflective',
    ],
  },
  {
    title: 'Table 16.1 - Mounting Forms',
    content: [
      'Roadside: All road types with adequate space',
      'Cantilever: Economical for smaller signs',
      'Gantry: Heavy traffic, \u22653 lanes',
      'Butterfly: Low speed or crash cushion',
    ],
  },
  {
    title: 'Section 16.3.2.4 - Stack Type Signs',
    content: [
      'Simple junctions with \u22643 directions',
      'Arrow and panel centered',
      'Arrows at 22.5\u00b0 increments',
      'Forward: arrow right, right-aligned',
    ],
  },
  {
    title: 'Section 16.3.2.5 - Destination Signs',
    content: [
      'Posted at major intersections',
      'Max 3 destinations',
      '2 languages: English + Hindi/Local',
      'Forward top, Left middle, Right bottom',
    ],
  },
  {
    title: 'Section 16.3.4 - Reassurance Signs',
    content: [
      '60m beyond far shoulder/curb line',
      'Major interchanges: within 200m',
      'Spacing \u226410 km on highways',
    ],
  },
  {
    title: 'Section 17 - Facility Signs',
    content: [
      'Blue background, white square',
      'Black symbol',
      'Size: 600mm x 800mm',
    ],
  },
];

export default function ReferenceModal({ isOpen, onClose }) {
  return (
    <Modal
      title="IRC:67-2022 Reference"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={700}
      style={{ maxHeight: '80vh' }}
    >
      <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '8px 0' }}>
        {SECTIONS.map((section, i) => (
          <Card
            key={i}
            size="small"
            style={{ marginBottom: 16 }}
            title={<Title level={5} style={{ margin: 0, fontSize: 13 }}>{section.title}</Title>}
          >
            <List
              size="small"
              dataSource={section.content}
              renderItem={(item) => (
                <List.Item style={{ padding: '4px 0', border: 'none' }}>
                  <Text type="secondary" style={{ fontSize: 12 }}>• {item}</Text>
                </List.Item>
              )}
            />
          </Card>
        ))}
      </div>
    </Modal>
  );
}
